// src/pages/ServicesPage.tsx
import React, { useEffect } from "react";
import { useLocation, Link } from "react-router-dom"; // Import Link for breadcrumbs
import servicebg from "../assets/img/page-title-bg-2.jpg"; // Update with the correct path to your hero image
import ServiceDetailSection from "../sections/Services/Services/ServiceDetailSection";
import {
  digitalMarketingServices,
  softwareDevelopmentServices,
} from "../sections/Services/Services/servicesData";
import softwareServiceImg from "../assets/img/services-details/services-1.jpg"; // Update with the correct path to your image
import DigitalMarketingServiceImg from "../assets/img/services-details/services-2.jpg"; // Update with the correct path to your image
// You might want to import your hero background image
// import servicesHeroBg from '../assets/images/your-services-hero-bg.jpg';
// Or if it's in public: const servicesHeroBg = "/img/services-details/hero-bg.jpg"; // Update with actual path

const ServicesPage: React.FC = () => {
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      setTimeout(() => {
        const element = document.getElementById(location.hash.substring(1));
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }, 100);
    } else {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  return (
    <div className="services-main-wrapper">
      {" "}
      {/* Overall container */}
      {/* Start Page Title Area - This needs to match your design's hero section */}
      <div
        className="page-title-area bg-custom-overlay relative z-0"
        style={{ height: "400px" }}
      >
        {" "}
        {/* Add relative and z-0 for content to overlap */}
        {/* Background Image/Overlay: Using inline style for simplicity, but consider a dedicated CSS class */}
        <div
          className="absolute inset-0 bg-cover bg-center bg-no-repeat"
          style={{ backgroundImage: `url('${servicebg}')` }} // No height here, inset-0 covers parent
        ></div>
        {/* Dark overlay: Also covers the parent's 500px height */}
        <div className="absolute inset-0 bg-slate-600 opacity-55"></div>{" "}
        {/* Adjust opacity as needed */}
        <div className="relative z-10 d-table min-h-[300px] flex items-center w-full">
          {" "}
          {/* Adjusted for height and centering */}
          <div className="d-table-cell w-full">
            <div className="container mx-auto px-4 max-w-6xl text-center text-white">
              <div className="page-title-content">
                <h2 className="text-5xl font-bold mb-3">Services Details</h2>
                <ul className="flex justify-center space-x-2 text-lg">
                  <li>
                    <Link to="/" className="hover:underline">
                      Home
                    </Link>
                  </li>
                  <li>/</li> {/* Separator */}
                  <li>Services Details</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* End Page Title Area */}
      {/* Start Services Details Area - Main content section */}
      {/* Main Services Content Area */}
      <section className="services-details-area py-16 bg-light-gray">
        <div className="container mx-auto px-4 max-w-6xl">
          <div className="services-details-overview">
            <div className="grid grid-cols-1 gap-y-8">
              {/* Software Development Consulting Title */}
              <div className="text-center mb-10" id="web-development-main">
                <h2 className="text-4xl font-bold text-gray-800">
                  Software Development Consulting We Provide
                </h2>
              </div>

              {/* Image below Software Development Consulting Title */}
              <div className="col-lg-12 col-md-12 mb-8">
                <div className="services-step-wrapper">
                  <img
                    src={softwareServiceImg} // Update with the correct path to your image
                    alt="Software Development"
                    className="mx-auto rounded-lg shadow-lg"
                  />
                </div>
              </div>

              {/* Render Software Development Services from data file */}
              {softwareDevelopmentServices.map((service) => (
                <ServiceDetailSection
                  key={service.id} // Important for React list rendering
                  id={service.id}
                  title={service.title}
                  content={service.content}
                />
              ))}

              {/* Digital Marketing Services We Provide Title */}

              <div className="text-center mb-10" id="services-step-title">
                <h2 className="text-4xl font-bold text-gray-800">
                  Digital Marketing Services We Provide
                </h2>
              </div>

              {/* Image below Digital Marketing Services Title */}
              <div className="col-lg-12 col-md-12 mb-8">
                <div className="services-step-wrapper">
                  <img
                    src={DigitalMarketingServiceImg}
                    alt="Digital Marketing"
                    className="mx-auto rounded-lg shadow-lg"
                  />
                </div>
              </div>

              {/* Render Digital Marketing Services from data file */}
              {digitalMarketingServices.map((service) => (
                <ServiceDetailSection
                  key={service.id} // Important for React list rendering
                  id={service.id}
                  title={service.title}
                  content={service.content}
                />
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* End Services Details Area */}
    </div>
  );
};

export default ServicesPage;
